import axios from 'axios'

const state = {
    setting: {},
    settings: {},
    setting_errors: {},
    setting_loading: false,
}

const getters = {
    setting: state => state.setting,
    settings: state => state.settings,
    setting_errors: state => state.setting_errors,
    setting_loading: state => state.setting_loading,
}

const mutations = {
    setSetting(state, setting) {
        state.setting = setting
    },
    setSettings(state, settings) {
        state.settings = settings
    },
    setSettingErrors(state, setting_errors) {
        state.setting_errors = setting_errors
    },
    setSettingLoading(state, setting_loading) {
        state.setting_loading = setting_loading
    },
}

const actions = {
    async storeSetting({commit}, data) {
        commit('setSettingLoading', true)
        commit('setSettingErrors', {})
        try {
            let response = await axios.post(`/api/settings/store`, data)
            commit('setSettingLoading', false)
            commit('setSettingErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setSettingLoading', false)
            commit('setSettingErrors', error.response.data.errors)
            return false
        }
    },
    async getSettings({commit}, data) {
        commit('setSettingLoading', true)
        try {
            let response = await axios.get(`/api/site/settings`, data)
            let settings = {}
            for(let setting of response.data?.data)
                settings[setting.key] = setting.value
            commit('setSettings', settings)
            commit('setSettingLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setSettingLoading', false)

            return false
        }
    },

    async getSetting({commit}, id) {
        try {
            let response = await axios.get(`/api/settings/${id}/show`)
            commit('setSetting', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },

    async destroySetting({commit}, id) {
        commit('setSettingLoading', true)
        try {
            let response = await axios.delete(`/api/settings/${id}/destroy`)
            commit('setSettingLoading', false)

            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setSettingLoading', false)
            return false
        }
    },
    async updateSetting({commit}, data) {
        commit('setSettingLoading', true)
        commit('setSettingErrors', {})
        try {
            let response = await axios.put(`/api/settings/${data.id}/update`, data)
            commit('setSettingLoading', false)
            commit('setSettingErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setSettingLoading', false)
            commit('setSettingErrors', error.response.data.errors)
            return false
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}